export enum DokfySystemApiEnum {
    DOKFY_API = 'DOKFY_API',
}
